import type { Tour } from '../tour-types';

/**
 * Performance: how the running experiments are converting. Every anchor is on screen once
 * there is data, apart from the row step, which needs a row in one of the two lists. The
 * shared scope picker is left to the Health tour.
 */
export const performanceTour: Tour = {
  key: 'performance',
  version: 1,
  routes: ['/performance'],
  steps: [
    {
      anchor: 'performance-stats',
      placement: 'bottom',
      title: 'At a glance',
      body: 'How many experiments are in view, and what share of them convert well (Positive) or poorly (Negative).',
    },
    {
      anchor: 'performance-trends',
      placement: 'top',
      title: 'Positive and negative',
      body: 'The experiments with a high conversion rate, and those with a low one, to spot what is working and what may need stopping. Expand either list to give it the full width.',
    },
    {
      anchor: 'performance-row',
      title: 'Open a row',
      body: 'Shows its conversion rate, its revenue against the control, and the figures split by currency. The name opens the experiment itself.',
    },
    {
      anchor: 'performance-all',
      placement: 'top',
      title: 'All experiments',
      body: 'Every experiment in scope, grouped by website, including those in the middle band that neither list shows.',
    },
  ],
};
